import AddIcon from '@mui/icons-material/Add'
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd'
import Button from '@mui/material/Button'
import { useMemo, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { PageHeader } from '../components/common/PageHeader'
import { ApplyTemplateDialog } from '../components/tasks/ApplyTemplateDialog'
import { TaskDialog } from '../components/tasks/TaskDialog'
import { EMPTY_FILTERS, TaskFilters, type TaskFilterState } from '../components/tasks/TaskFilters'
import { TasksTable } from '../components/tasks/TasksTable'
import type { QueryParams } from '../lib/api'

export function TasksPage() {
  const [searchParams, setSearchParams] = useSearchParams()
  const [filters, setFilters] = useState<TaskFilterState>(EMPTY_FILTERS)
  const [createOpen, setCreateOpen] = useState(false)
  const [templateOpen, setTemplateOpen] = useState(false)

  // The dashboard and the notification bell deep-link into a specific task.
  const openTaskId = searchParams.get('taskId')

  const closeTaskDialog = () => {
    const next = new URLSearchParams(searchParams)
    next.delete('taskId')
    setSearchParams(next, { replace: true })
  }

  const openTask = (taskId: string) => {
    const next = new URLSearchParams(searchParams)
    next.set('taskId', taskId)
    setSearchParams(next, { replace: true })
  }

  const query = useMemo<QueryParams>(
    () => ({
      search: filters.search || undefined,
      assignedUserId: filters.assignedUserId || undefined,
      clientId: filters.clientId || undefined,
      caseId: filters.caseId || undefined,
      projectId: filters.projectId || undefined,
      status: filters.status,
      priority: filters.priority,
      topLevelOnly: filters.topLevelOnly ? true : undefined,
      pageSize: 200,
    }),
    [filters]
  )

  return (
    <>
      <PageHeader
        title="משימות"
        subtitle="כל המשימות של כל העובדים — עריכה ישירה בטבלה"
        actions={
          <>
            <Button startIcon={<PlaylistAddIcon />} onClick={() => setTemplateOpen(true)}>
              יצירה מתבנית
            </Button>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => setCreateOpen(true)}
            >
              משימה חדשה
            </Button>
          </>
        }
      />

      <TaskFilters value={filters} onChange={setFilters} />

      {/* 356px = everything around the grid: app bar, page padding, header and the
          filter bar. Too small and the page grows a scrollbar for the difference. */}
      <TasksTable
        query={query}
        onOpenTask={openTask}
        height="calc(100vh - 356px)"
      />

      <TaskDialog open={createOpen} onClose={() => setCreateOpen(false)} />
      <TaskDialog open={Boolean(openTaskId)} taskId={openTaskId} onClose={closeTaskDialog} />
      <ApplyTemplateDialog
        open={templateOpen}
        onClose={() => setTemplateOpen(false)}
        onApplied={openTask}
      />
    </>
  )
}
